import { Button } from "antd";
import StartPathIcon from "components/svg-icons/start-path-icon";
import { ProjectContext } from "context/ProjectProvider";
import { useContext } from "react";

export default function WelcomeWindow({
  onGetStarted
}: {
  onGetStarted: () => void;
}) {
  const { projectDetails } = useContext(ProjectContext);
  return (
    <div className="flex w-full h-full">
      <StartPathIcon />

      <div className="flex flex-col justify-between items-center w-full h-full py-32">
        <div className="flex flex-col space-y-5 justify-center items-center w-full">
          <div className="font-bold text-xs">WELCOME</div>
          <div className="font-bold text-2xl">{projectDetails?.name}</div>
        </div>

        <div className="flex flex-col justify-center items-center space-y-7">
          <div className="font-bold">Let&apos;s get you set up.</div>
          <Button
            onClick={onGetStarted}
            type="primary"
            className="bg-ciq-blue-600 rounded border-none w-[121px] text-center hover:bg-ciq-blue-600"
            data-testid="index-button-welcome-get-started"
          >
            Get Started
          </Button>
        </div>

        {/* <div className="flex justify-center items-center font-bold pt-10 ">
          {projectDetails?.name}
        </div>
        <div className="flex justify-center items-center text-2xl font-bold w-full py-2">
          Welcome to ConstructivIQ
        </div>
        <div className="flex justify-center items-center" />
        <div className="flex justify-center items-center font-bold -mt-8">
          Let&apos;s get you set up.
        </div>
        <div className="flex justify-center items-center mt-14">
          <Button
            onClick={onGetStarted}
            type="primary"
            className="bg-ciq-blue-600 rounded border-none w-[121px] text-center hover:bg-ciq-blue-600"
            >
            Get Started
          </Button>
        </div> */}
      </div>
    </div>
  );
}
